export enum METADATA_PERMISSIONS {
    METADATA_EDIT = 'METADATA_EDIT',
    METADATA_DELETE = 'METADATA_DELETE',
}
